import React from 'react'
import '../assets/styles/palmares.css'
import { Link } from 'react-router-dom'

function Palmares() {
  return (
    <div className="palmares">
        <h1>Prix et nominations depuis 1994</h1>
        <a href='https://www.senscritique.com/liste/palmares_complet_du_festival_de_gerardmer/734178' target="blank"><button>Grand prix depuis 1994</button></a>
        <a href='https://www.allocine.fr/festivals/festival-93/edition-18356279/palmares/' target="blank"><button>Tous les prix depuis 1994</button></a>
          <div className="buttonRetour">
<Link to='/palmares23'><button style={{margin: "20px 0px", padding: "10px", width: "300px", backgroundColor:"orange", border: "none", borderRadius: "10px"}}>PALMARES 2023</button></Link>
          </div>
          <div className="buttonRetour">
<Link to='/accueil'><button style={{margin: "20px 0px", padding: "10px", width: "200px", backgroundColor:"red", border: "none", borderRadius: "10px"}}>RETOUR ACCUEIL</button></Link>
          </div>
    </div>
  )
}

export default Palmares